exports.setDelay = delay => new Promise(resolve => {
    setTimeout(() => resolve(), delay);
});